<form class="row">
  <div class="col-md-12 checkbox d-flex justify-content-end mb-3 mt-4">
    <label>
      <input
        name="SelectAllPermissionAdmins"
        [(ngModel)]="permissionAdmin.selectAllPermissionAdmin.Selected"
        class="cc-filter-checkbox set-pointer-events"
        type="checkbox"
        kendoCheckBox
        [disabled]="isUkgDefaultGroup || isViewOnly || !disabledSelectAllAdmin"
        (change)="valueChangeByselectAllPermissionsAdmin($event)"
      />
      {{ "_Permission_Select_All_Admin_Permissions_" | translate }}
    </label>
  </div>
  <ng-container *ngIf="isLoaded">
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Admin_General_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="generalselectall"
                [(ngModel)]="permissionAdmin.General.selectAll"
                (change)="selectAllGeneral()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.General.viewEditSystemConfiguration
                    .Enabled ||
                  !permissionAdmin.General.viewEditLocalization.Enabled ||
                  !permissionAdmin.General.dataImportExport.Enabled
                "
              />

              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="1"
                  (change)="onAdminGeneralItemChange()"
                  name="viewEditSystemConfiguration"
                  [(ngModel)]="
                    permissionAdmin.General.viewEditSystemConfiguration.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.General.viewEditSystemConfiguration.Enabled
                  "
                />
                {{
                  permissionAdmin.General.viewEditSystemConfiguration
                    .DisplayName | translate
                }}
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="4"
                  (change)="onAdminGeneralItemChange()"
                  name="viewEditLocalization"
                  [(ngModel)]="
                    permissionAdmin.General.viewEditLocalization.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.General.viewEditLocalization.Enabled
                  "
                />
                {{
                  permissionAdmin.General.viewEditLocalization.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
          <div class="col-md-6 mt-1">
            <div class="checkbox">
              <label>
                <input
                  id="3"
                  name="dataImport"
                  (change)="onAdminGeneralItemChange()"
                  [(ngModel)]="
                    permissionAdmin.General.dataImportExport.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAdmin.General.dataImportExport.Enabled"
                />
                {{
                  permissionAdmin.General.dataImportExport.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
          <div class="col-md-6" *ngIf="tenantId == 1 && isUkgDefaultGroup">
            <div class="checkbox">
              <label>
                <input
                  id="5"
                  (change)="onAdminGeneralItemChange()"
                  name="LicensingEditView"
                  [(ngModel)]="
                    permissionAdmin.General.viewEditLicensing.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.General.viewEditLicensing.Enabled
                  "
                />
                {{
                  permissionAdmin.General.viewEditLicensing.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Locations_Text_" | translate }}
          </h6>
          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllLocations()"
                [(ngModel)]="permissionAdmin.Location.selectAll"
                name="locationlSelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.Location.viewLocations.Enabled ||
                  !permissionAdmin.Location.addLocations.Enabled ||
                  !permissionAdmin.Location.editLocations.Enabled ||
                  !permissionAdmin.Location.activateDeactivateLocations.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="6"
                  (change)="onAdminLocationItemChange()"
                  name="
                            viewLocations"
                  [(ngModel)]="permissionAdmin.Location.viewLocations.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAdmin.Location.viewLocations.Enabled"
                />
                {{
                  permissionAdmin.Location.viewLocations.DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="7"
                    (change)="onAdminLocationItemChange()"
                    name="
                                addLocations"
                    [(ngModel)]="permissionAdmin.Location.addLocations.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Location.addLocations.Enabled ||
                      !permissionAdmin.Location.viewLocations.Selected
                    "
                  />
                  {{
                    permissionAdmin.Location.addLocations.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="8"
                    (change)="onAdminLocationItemChange()"
                    name="
                                editLocations"
                    [(ngModel)]="
                      permissionAdmin.Location.editLocations.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Location.editLocations.Enabled ||
                      !permissionAdmin.Location.viewLocations.Selected
                    "
                  />
                  {{
                    permissionAdmin.Location.editLocations.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="9"
                    (change)="onAdminLocationItemChange()"
                    name="
                                activateDeactivateLocations"
                    [(ngModel)]="
                      permissionAdmin.Location.activateDeactivateLocations
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Location.activateDeactivateLocations
                        .Enabled ||
                      !permissionAdmin.Location.viewLocations.Selected
                    "
                  />
                  {{
                    permissionAdmin.Location.activateDeactivateLocations
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Product_Categories_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllViewAddEditProductCategories()"
                [(ngModel)]="
                  permissionAdmin.ViewAddEditDeleteProductCategory.selectAll
                "
                name="productCategorySelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.ViewAddEditDeleteProductCategory
                    .viewAddEditDeleteProductCategory.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="10"
                  (change)="onAdminViewAddEditProductCategoriesItemChange()"
                  name="viewAddEditDeleteProductCategory"
                  [(ngModel)]="
                    permissionAdmin.ViewAddEditDeleteProductCategory
                      .viewAddEditDeleteProductCategory.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.ViewAddEditDeleteProductCategory
                      .viewAddEditDeleteProductCategory.Enabled
                  "
                />
                {{
                  permissionAdmin.ViewAddEditDeleteProductCategory
                    .viewAddEditDeleteProductCategory.DisplayName | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Products_Services_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllProductAndService()"
                [(ngModel)]="permissionAdmin.ProductAndService.selectAll"
                name="productServiceSelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  (!permissionAdmin.ProductAndService.viewProductsServices
                    .Enabled &&
                    !permissionAdmin.ProductAndService.addProductsServices
                      .Enabled) ||
                  !permissionAdmin.ProductAndService.editProductsAndServices
                    .Enabled ||
                  !permissionAdmin.ProductAndService.editBasicProductAndServices
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="11"
                  (change)="onAdminProductAndServiceItemChange()"
                  name="addAddEditDeleteProductCategory"
                  [(ngModel)]="
                    permissionAdmin.ProductAndService.viewProductsServices
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.ProductAndService.viewProductsServices
                      .Enabled
                  "
                />
                {{
                  permissionAdmin.ProductAndService.viewProductsServices
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="12"
                    (change)="onAdminProductAndServiceItemChange()"
                    name="addps"
                    [(ngModel)]="
                      permissionAdmin.ProductAndService.addProductsServices
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ProductAndService.addProductsServices
                        .Enabled ||
                      !permissionAdmin.ProductAndService.viewProductsServices
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ProductAndService.addProductsServices
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="13"
                    (change)="onAdminProductAndServiceItemChange()"
                    name="editAddEditDeleteProductCategory"
                    [(ngModel)]="
                      permissionAdmin.ProductAndService.editProductsAndServices
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ProductAndService.editProductsAndServices
                        .Enabled ||
                      !permissionAdmin.ProductAndService.viewProductsServices
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ProductAndService.editProductsAndServices
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="tab-indent mt-1">
                <div class="checkbox">
                  <label>
                    <input
                      id="68"
                      (change)="onAdminProductAndServiceItemChange()"
                      name="editBasicProductAndServices"
                      [(ngModel)]="
                        permissionAdmin.ProductAndService
                          .editBasicProductAndServices.Selected
                      "
                      class="cc-filter-checkbox"
                      type="checkbox"
                      kendoCheckBox
                      [disabled]="
                        !permissionAdmin.ProductAndService
                          .editBasicProductAndServices.Enabled ||
                        !permissionAdmin.ProductAndService
                          .editProductsAndServices.Selected ||
                        !permissionAdmin.ProductAndService.viewProductsServices
                          .Selected
                      "
                    />
                    {{
                      permissionAdmin.ProductAndService
                        .editBasicProductAndServices.DisplayName | translate
                    }}
                  </label>
                </div>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="85"
                    (change)="onAdminProductAndServiceItemChange()"
                    name="activateDeactivateProductServices"
                    [(ngModel)]="
                      permissionAdmin.ProductAndService
                        .activateDeactivateProductsServices.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ProductAndService
                        .activateDeactivateProductsServices.Enabled ||
                      !permissionAdmin.ProductAndService.viewProductsServices
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ProductAndService
                      .activateDeactivateProductsServices.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="86"
                    (change)="onAdminProductAndServiceItemChange()"
                    name="deleteProductServices"
                    [(ngModel)]="
                      permissionAdmin.ProductAndService.deleteProductsServices
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ProductAndService.deleteProductsServices
                        .Enabled ||
                      !permissionAdmin.ProductAndService.viewProductsServices
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ProductAndService.deleteProductsServices
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Admin_Groups_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllGroups()"
                [(ngModel)]="permissionAdmin.Groups.selectAll"
                name="groupSelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.Groups.viewPermissionGroups.Enabled ||
                  !permissionAdmin.Groups.addPermissionGroups.Enabled ||
                  !permissionAdmin.Groups.editPermissionGroups.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="14"
                  (change)="onAdminGroupsItemChange()"
                  name="
                                viewPermissionGroups"
                  [(ngModel)]="
                    permissionAdmin.Groups.viewPermissionGroups.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.Groups.viewPermissionGroups.Enabled
                  "
                />
                {{
                  permissionAdmin.Groups.viewPermissionGroups.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="15"
                    (change)="onAdminGroupsItemChange()"
                    name="
                                    addPermissionGroups"
                    [(ngModel)]="
                      permissionAdmin.Groups.addPermissionGroups.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Groups.addPermissionGroups.Enabled ||
                      !permissionAdmin.Groups.viewPermissionGroups.Selected
                    "
                  />
                  {{
                    permissionAdmin.Groups.addPermissionGroups.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="16"
                    (change)="onAdminGroupsItemChange()"
                    name="
                                    editPermission"
                    [(ngModel)]="
                      permissionAdmin.Groups.editPermissionGroups.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Groups.editPermissionGroups.Enabled ||
                      !permissionAdmin.Groups.viewPermissionGroups.Selected
                    "
                  />
                  {{
                    permissionAdmin.Groups.editPermissionGroups.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="17"
                    (change)="onAdminGroupsItemChange()"
                    name="
                                    deletePermission"
                    [(ngModel)]="
                      permissionAdmin.Groups.deletePermissionGroups.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Groups.deletePermissionGroups.Enabled ||
                      !permissionAdmin.Groups.viewPermissionGroups.Selected
                    "
                  />
                  {{
                    permissionAdmin.Groups.deletePermissionGroups.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Users_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllUsers()"
                [(ngModel)]="permissionAdmin.Users.selectAll"
                name="selectAllUsers"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.Users.viewUsers.Enabled ||
                  !permissionAdmin.Users.addUsers.Enabled ||
                  !permissionAdmin.Users.editUsers.Enabled ||
                  !permissionAdmin.Users.deleteUsers.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="18"
                  (change)="onAdminUsersItemChange()"
                  name="viesUsers
                                    editPermission"
                  [(ngModel)]="permissionAdmin.Users.viewUsers.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAdmin.Users.viewUsers.Enabled"
                />
                {{ permissionAdmin.Users.viewUsers.DisplayName | translate }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="19"
                    (change)="onAdminUsersItemChange()"
                    name="addUsr"
                    [(ngModel)]="permissionAdmin.Users.addUsers.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Users.addUsers.Enabled ||
                      !permissionAdmin.Users.viewUsers.Selected
                    "
                  />
                  {{ permissionAdmin.Users.addUsers.DisplayName | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="20"
                    (change)="onAdminUsersItemChange()"
                    name="edtUsr"
                    [(ngModel)]="permissionAdmin.Users.editUsers.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Users.editUsers.Enabled ||
                      !permissionAdmin.Users.viewUsers.Selected
                    "
                  />
                  {{ permissionAdmin.Users.editUsers.DisplayName | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="95"
                    (change)="onAdminUsersItemChange()"
                    name="delU"
                    [(ngModel)]="permissionAdmin.Users.deleteUsers.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Users.deleteUsers.Enabled ||
                      !permissionAdmin.Users.viewUsers.Selected
                    "
                  />
                  {{
                    permissionAdmin.Users.deleteUsers.DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CC-417 - Hide until post MVP - Don't Remove-->
    <!-- <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="sub-heading">Members</div>
            <div class="checkbox d-flex justify-content-center">
                <label>
                    <input id="" (change)="selectAllMembers()" [(ngModel)]="permissionAdmin.Members.selectAll"
                        name="MembersSelectAll" class="cc-filter-checkbox" type="checkbox" kendoCheckBox [disabled]="!permissionAdmin.Members.viewMembers.Enabled 
                            && !permissionAdmin.Members.importMembers.Enabled" [checked]="permissionAdmin.Members.importMembers.Selected
                            && permissionAdmin.Members.viewMembers.Selected" />
                    Select All
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="checkbox">
                    <label>
                        <input id="22" (change)="onAdminUMembersItemChange()" name="viewMember"
                            [(ngModel)]="permissionAdmin.Members.viewMembers.Selected" class="cc-filter-checkbox"
                            type="checkbox" kendoCheckBox [disabled]="!permissionAdmin.Members.viewMembers.Enabled" />
                        {{permissionAdmin.Members.viewMembers.DisplayName}}
                    </label>
                </div>
                <div class="tab-indent mt-1">
                    <div class="checkbox">
                        <label>
                            <input id="23" (change)="onAdminUMembersItemChange()" name="importMember"
                                [(ngModel)]="permissionAdmin.Members.importMembers.Selected" class="cc-filter-checkbox"
                                type="checkbox" kendoCheckBox
                                [disabled]="!permissionAdmin.Members.importMembers.Enabled" />
                            {{permissionAdmin.Members.importMembers.DisplayName}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="col-md-12 col-lg-6" *ngIf="tenantId == 1 && isUkgDefaultGroup">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Admin_Client_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllClients()"
                [(ngModel)]="permissionAdmin.Clients.selectAll"
                name="clientSelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.Clients.viewClients.Enabled ||
                  !permissionAdmin.Clients.addClients.Enabled ||
                  !permissionAdmin.Clients.changeClients.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="24"
                  (change)="onAdminClientsItemChange()"
                  name="
                                viewClients"
                  [(ngModel)]="permissionAdmin.Clients.viewClients.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAdmin.Clients.viewClients.Enabled"
                />
                {{
                  permissionAdmin.Clients.viewClients.DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="25"
                    (change)="onAdminClientsItemChange()"
                    name="
                                    addClients"
                    [(ngModel)]="permissionAdmin.Clients.addClients.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Clients.addClients.Enabled ||
                      !permissionAdmin.Clients.viewClients.Selected
                    "
                  />
                  {{
                    permissionAdmin.Clients.addClients.DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="checkbox mt-1">
              <label>
                <input
                  id="26"
                  (change)="onAdminClientsItemChange()"
                  name="changeClients"
                  [(ngModel)]="permissionAdmin.Clients.changeClients.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAdmin.Clients.changeClients.Enabled"
                />
                {{
                  permissionAdmin.Clients.changeClients.DisplayName | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6" *ngIf="isLTLicenseEnabled$ | async">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Admin_Alerts_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllGlobalAlert()"
                [(ngModel)]="permissionAdmin.ViewGlobalAlerts.selectAll"
                name="globalalertSelectAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled ||
                  !permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Enabled ||
                  !permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Enabled ||
                  !permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts
                    .Enabled ||
                  !permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="27"
                  (change)="onAdminGlobalAlertItemChange()"
                  name="viegobalAlerts"
                  [(ngModel)]="
                    permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled
                  "
                />
                {{
                  permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="28"
                    (change)="onAdminGlobalAlertItemChange()"
                    name="addgal"
                    [(ngModel)]="
                      permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ViewGlobalAlerts.addGlobalAlerts
                        .Enabled ||
                      !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="29"
                    (change)="onAdminGlobalAlertItemChange()"
                    name="editgal"
                    [(ngModel)]="
                      permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ViewGlobalAlerts.editGlobalAlerts
                        .Enabled ||
                      !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ViewGlobalAlerts.editGlobalAlerts
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="30"
                    (change)="onAdminGlobalAlertItemChange()"
                    name="delgal"
                    [(ngModel)]="
                      permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts
                        .Enabled ||
                      !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts
                        .Selected
                    "
                  />
                  {{
                    permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="62"
                  (change)="onAdminGlobalAlertItemChange()"
                  name="vaedgl"
                  [(ngModel)]="
                    permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
                      .Enabled
                  "
                />
                {{
                  permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
                    .DisplayName | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6" *ngIf="isLTLicenseEnabled$ | async">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Kiosks_Text_" | translate }}
          </h6>
          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                (change)="selectAllKiosk()"
                name="
                            kioskSelectAll"
                [(ngModel)]="permissionAdmin.Kiosk.selectAll"
                name="kioskSAll"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAdmin.Kiosk.viewKioskConfiguration.Enabled ||
                  !permissionAdmin.Kiosk.addKioskConfiguration.Enabled ||
                  !permissionAdmin.Kiosk.editKioskConfiguration.Enabled ||
                  !permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="31"
                  (change)="onAdminKioskItemChange()"
                  name="viKiosk"
                  [(ngModel)]="
                    permissionAdmin.Kiosk.viewKioskConfiguration.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAdmin.Kiosk.viewKioskConfiguration.Enabled
                  "
                />
                {{
                  permissionAdmin.Kiosk.viewKioskConfiguration.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="32"
                    (change)="onAdminKioskItemChange()"
                    name="addks"
                    [(ngModel)]="
                      permissionAdmin.Kiosk.addKioskConfiguration.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Kiosk.addKioskConfiguration.Enabled ||
                      !permissionAdmin.Kiosk.viewKioskConfiguration.Selected
                    "
                  />
                  {{
                    permissionAdmin.Kiosk.addKioskConfiguration.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="33"
                    (change)="onAdminKioskItemChange()"
                    name="edKsk"
                    [(ngModel)]="
                      permissionAdmin.Kiosk.editKioskConfiguration.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Kiosk.editKioskConfiguration.Enabled ||
                      !permissionAdmin.Kiosk.viewKioskConfiguration.Selected
                    "
                  />
                  {{
                    permissionAdmin.Kiosk.editKioskConfiguration.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="34"
                    (change)="onAdminKioskItemChange()"
                    name="deks"
                    [(ngModel)]="
                      permissionAdmin.Kiosk.deleteKioskConfiguration.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled ||
                      !permissionAdmin.Kiosk.viewKioskConfiguration.Selected
                    "
                  />
                  {{
                    permissionAdmin.Kiosk.deleteKioskConfiguration.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>
